// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function handleEvent(onClickOutside, state, event) {
  if (event.type === "touchend") {
    state.isTouch.contents = true;
  }
  let match = event.type;
  let match$1 = state.isTouch.contents;
  let match$2 = state.ownRef.contents;
  if (match === "click" && match$1) {
    return;
  }
  if (match$2 === undefined) {
    return;
  }
  let targetElement = event.target;
  if (Primitive_option.valFromOption(match$2).contains(targetElement)) {
    return;
  } else {
    return onClickOutside();
  }
}

let fullSizeStyle = {
  height: "100%",
  width: "100%"
};

let emptyStyle = {};

function ClickOutside(props) {
  let onClickOutside = props.onClickOutside;
  let __fullSize = props.fullSize;
  let fullSize = __fullSize !== undefined ? __fullSize : true;
  let match = React.useState(() => ({
    ownRef: {
      contents: undefined
    },
    isTouch: {
      contents: false
    }
  }));
  let state = match[0];
  React.useEffect(() => {
    let handleEvent$1 = extra => handleEvent(onClickOutside, state, extra);
    document.addEventListener("touchend", handleEvent$1, true);
    document.addEventListener("click", handleEvent$1, true);
    return () => {
      document.removeEventListener("touchend", handleEvent$1, true);
      document.removeEventListener("click", handleEvent$1, true);
    };
  }, [
    onClickOutside,
    state
  ]);
  return JsxRuntime.jsx("div", {
    children: props.children,
    ref: Primitive_option.some(r => {
      state.ownRef.contents = (r == null) ? undefined : Primitive_option.some(r);
    }),
    style: fullSize ? fullSizeStyle : emptyStyle
  });
}

let Event;

let Element;

let Document;

let make = ClickOutside;

exports.Event = Event;
exports.Element = Element;
exports.Document = Document;
exports.handleEvent = handleEvent;
exports.fullSizeStyle = fullSizeStyle;
exports.emptyStyle = emptyStyle;
exports.make = make;
/* react Not a pure module */
